import { DEFAULT_VOLUME_BAR_MULTIPLIER, MAX_GAIN_MULTIPLIER } from "./avatar-volume-utils";

const MIN_GAIN_MULTIPLIER = 0;
const LOCAL_MUTE_EPSILON = 0.0001;

export function sanitizeAvatarGain(gainMultiplier, fallback = DEFAULT_VOLUME_BAR_MULTIPLIER) {
  const numericGain = Number(gainMultiplier);
  const fallbackGain = Number.isFinite(Number(fallback)) ? Number(fallback) : DEFAULT_VOLUME_BAR_MULTIPLIER;

  if (!Number.isFinite(numericGain)) {
    return Math.min(MAX_GAIN_MULTIPLIER, Math.max(MIN_GAIN_MULTIPLIER, fallbackGain));
  }

  return Math.min(MAX_GAIN_MULTIPLIER, Math.max(MIN_GAIN_MULTIPLIER, numericGain));
}

export function isAvatarLocallyMutedByGain(gainMultiplier) {
  const numericGain = Number(gainMultiplier);
  if (!Number.isFinite(numericGain)) return false;

  return numericGain <= LOCAL_MUTE_EPSILON;
}

export function resolveInitialAvatarGain({ runtimeGain, prefGain, prefMutedLegacy }) {
  if (Number.isFinite(Number(runtimeGain))) {
    return sanitizeAvatarGain(runtimeGain);
  }

  if (prefMutedLegacy === true) {
    return 0;
  }

  if (Number.isFinite(Number(prefGain))) {
    return sanitizeAvatarGain(prefGain);
  }

  return DEFAULT_VOLUME_BAR_MULTIPLIER;
}

export function resolveGainForMuteToggle({ nextMuted, currentGain, lastNonZeroGain, prefGain }) {
  if (nextMuted) {
    return 0;
  }

  const candidates = [lastNonZeroGain, currentGain, prefGain, DEFAULT_VOLUME_BAR_MULTIPLIER];
  for (const candidate of candidates) {
    const normalized = sanitizeAvatarGain(candidate, 0);
    if (!isAvatarLocallyMutedByGain(normalized)) {
      return normalized;
    }
  }

  return DEFAULT_VOLUME_BAR_MULTIPLIER;
}

export function toLegacyMutedFlag(gainMultiplier) {
  return isAvatarLocallyMutedByGain(gainMultiplier);
}
